"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECORDING_DELAY_WAIT_TIME = void 0;
var RECORDING_DELAY_WAIT_TIME = exports.RECORDING_DELAY_WAIT_TIME = 15000; // Unit in milliseconds